import type { SeoData } from './seoData';
import { SITE_URL, FAVICON_URL } from './seoData';

let managedScripts: HTMLScriptElement[] = [];

function injectJsonLd(data: Record<string, unknown>): void {
  const script = document.createElement('script');
  script.type = 'application/ld+json';
  script.setAttribute('data-seo-jsonld', 'true');
  script.textContent = JSON.stringify(data);
  document.head.appendChild(script);
  managedScripts.push(script);
}

export function clearJsonLd(): void {
  managedScripts.forEach((script) => script.remove());
  managedScripts = [];
}

// Injects site-level schema (WebSite + Organization) plus route-specific
// Article schema when applicable. Kept separate from meta tag handling.
export function applyJsonLd(seo: SeoData): void {
  clearJsonLd();

  injectJsonLd({
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'AllChinaBuy Spreadsheet',
    url: SITE_URL,
    description:
      'AllChinaBuy Spreadsheet resource hub with product guides, seller reviews, shipping information, and buying guides.',
    inLanguage: ['en', 'fr', 'de', 'da'],
  });

  injectJsonLd({
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'AllChinaBuy Spreadsheet',
    url: SITE_URL,
    logo: FAVICON_URL,
    description: 'Independent resource hub for AllChinaBuy shoppers',
  });

  if (seo.type === 'article') {
    injectJsonLd({
      '@context': 'https://schema.org',
      '@type': 'Article',
      headline: seo.title,
      description: seo.description,
      image: seo.image ? [seo.image] : undefined,
      datePublished: seo.datePublished,
      dateModified: seo.dateModified,
      author: {
        '@type': 'Organization',
        name: 'AllChinaBuy Spreadsheet Editorial Team',
        url: SITE_URL,
      },
      publisher: {
        '@type': 'Organization',
        name: 'AllChinaBuy Spreadsheet',
        logo: {
          '@type': 'ImageObject',
          url: FAVICON_URL,
        },
      },
      mainEntityOfPage: seo.canonical,
      inLanguage: 'en',
    });
  }
}